export default __webpack_public_path__ + "static/media/Group 108.67646333.svg";